
import './btn-more/btn-more.js';
import './mobile-location/mobile-location';

import './form/form.js';
import './star-rating-static/Rating.js';
import './star-rating-static/RatingBindings.js';
import './payments-history/payments-history.js';


// WEBPACK FOOTER //
// ./src/common/modules/index.js